"use client";

import { useState } from "react";
import ShareIcon from "@heroicons/react/24/solid/ShareIcon";
import dynamic from "next/dynamic";
import { useTranslation } from "@/hooks/translationContext";

const CompanyShareModal = dynamic(
  () => import("../modals/company/ShareModal"),
  {
    ssr: false,
  },
);

export default function ShareButton({ slug, shareButtonText }: { slug: string, shareButtonText: string }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      {isOpen && (
        <CompanyShareModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          slug={slug}
        />
      )}

      <div>
        <button
          onClick={() => setIsOpen(true)}
          className="!py-1.5 border-assistant text-assistant border rounded-full font-medium hover:bg-assistant/10 duration-100 text-xs w-auto !h-[36px] !px-3 flex gap-2 items-center"
        >
          <ShareIcon className="size-5" />
          {shareButtonText || t("company-discount-share-title")}
        </button>
      </div>
    </>
  );
}
